import { connect } from 'react-redux';
import { VODCSSModules, VODBiEvents } from 'shared/utils/wix-connect';

import { showInfoValues } from 'default-settings';
import { isPreviewHover, getInfoActionVisibility } from 'shared/selectors/app-settings';

import { ThumbnailOverlayStripBase } from 'widget/components/videos-list/strip/thumbnail-overlay/thumbnail-overlay.js';

import styles from './thumbnail-overlay.styl';


@connect(state => ({
  isPreviewHover: isPreviewHover(state),
  isTitleAlwaysShown: getInfoActionVisibility(state) === showInfoValues.ALWAYS,
  isTitleNeverShown: getInfoActionVisibility(state) === showInfoValues.NEVER,
  isOnlySmallButtons: true,
}))
@VODBiEvents()
@VODCSSModules(styles)
export default class ThumbnailOverlayCompact extends ThumbnailOverlayStripBase {}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/video-list-item/thumbnail-overlay/thumbnail-overlay.js